import { Component } from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { State } from 'interfaces/state'
import { LocationOption } from 'interfaces/locations'
import { InputTheme } from 'interfaces/component'
import AutosuggestWrapped, { AutosuggestWrappedOwnProps } from 'components/atoms/inputs/AutosuggestWrapped'
import { registerLocationsAutosuggestActionCreator, destroyLocationsAutosuggestActionCreator, searchLocationsActionCreator } from 'actions/locationsActions'
import Registerable, { RegisterableDispatchProps, RegisterableOwnProps } from 'components/utils/Registerable'

type LocationFieldInnerOwnProps = {
  name: string
  theme?: InputTheme
  id: string
}

type LocationFieldInnerStateProps = {
  isLoading: boolean
  options: LocationOption[]
  lastSentQuery: string
}

type LocationFieldInnerDispatchProps = {
  searchLocations: (id: string, text: string) => void
}

type LocationFieldInnerProps = LocationFieldInnerStateProps & LocationFieldInnerDispatchProps & LocationFieldInnerOwnProps

class LocationFieldInner extends Component<LocationFieldInnerProps> {

  render () {
    const {
      name, theme,
      isLoading, lastSentQuery, options,
    } = this.props

    const autosuggestProps: AutosuggestWrappedOwnProps<number> = {
      autoComplete: 'off',
      label: 'Location',
      theme,
      isLoading,
      lastSentQuery,
      options,
      qaMarker: 'location',
      onRequestSuggestions: this.searchLocations,
      requestOptimization: false,
      shouldPlaceSelectedToInput: true,
    }

    return (
      <Field
        name={ name }
        component={ AutosuggestWrapped }
        props={ autosuggestProps }
      />
    )
  }

  private searchLocations = (query: string) => {
    const { searchLocations, id } = this.props
    searchLocations(id, query)
  }
}

const innerMapStateToProps = (state: State, { id }: LocationFieldInnerOwnProps): LocationFieldInnerStateProps => {
  const autosuggestState = state.app.locations.locations[id]

  return {
    isLoading: autosuggestState.loading,
    options: autosuggestState.options,
    lastSentQuery: autosuggestState.lastSentQuery,
  }
}

const innerMapDispatchToProps: LocationFieldInnerDispatchProps = ({
  searchLocations: searchLocationsActionCreator,
})

const LocationFieldInnerContainer = connect<
  LocationFieldInnerStateProps,
  LocationFieldInnerDispatchProps,
  LocationFieldInnerOwnProps
>(innerMapStateToProps, innerMapDispatchToProps)(LocationFieldInner)


// Registerable
const mapDispatchToProps: RegisterableDispatchProps = {
  register: registerLocationsAutosuggestActionCreator,
  destroy: destroyLocationsAutosuggestActionCreator,
}

const LocationField = connect<
  {},
  RegisterableDispatchProps,
  RegisterableOwnProps<LocationFieldInnerOwnProps>
>(undefined, mapDispatchToProps)(Registerable(LocationFieldInnerContainer))

export default LocationField
